import React, { useEffect, useState } from 'react'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import format from 'date-fns/format'

function DateRangeSelector ({
  formData,
  setFormData,
  setDateRangeOpen,
  dateRangeOpen,
  handleOnchangeDate
}) {
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ])

  // useEffect(() => {
  //   const selectedRange = dateRange[0]
  //   if (selectedRange.startDate && selectedRange.endDate) {
  //     setFormData({
  //       ...formData,
  //       departureDate: selectedRange.startDate,
  //       returnDate: selectedRange.endDate
  //     })
  //   }
  // }, [dateRange, setFormData])

  return (
    <div
      className='DateRange-Main'
      style={{ display: dateRangeOpen ? 'flex' : 'none' }}
    >
      {dateRangeOpen && (
        <div
          onClick={() => setDateRangeOpen(false)}
          className='GuestCounter-center'
        ></div>
      )}
      <div className='section-DateRange'>
        {dateRangeOpen && (
          <div className='DateRange-Date'>
            <DateRange
              editableDateInputs={true}
              onChange={item => {
                setDateRange([item.selection])
                handleOnchangeDate(item)
                // Automatically close date picker after selection if both dates are selected
                if (item.selection.startDate && item.selection.endDate) {
                  setDateRangeOpen(false)
                }
              }}
              onContextMenu={e => {
                e.preventDefault() // Prevent the default right-click menu
                setDateRangeOpen(false) // Close the date picker on right-click
              }}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              minDate={new Date()}
              months={1}
              direction='horizontal'
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DateRangeSelector
